import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import PhotoHolder from '../components/photo-holder'
import EmotionSelector from '../components/emotion-selector'
import AcceptButton from '../components/accept-button'
import RetryButton from '../components/retry-button'
import { useLocation } from "react-router-dom";
import { post } from '../config/api';
import { Link } from 'react-router-dom'
import './photo-approval.css'

const PhotoApproval = (props) => {
  const { user } = props;
  const location = useLocation();
  const imageURL = location.state.photoUrl;
  const [emotion, setEmotion] = useState('');

  useEffect(()=>{
    const getEmotion = async ()=>{
      const formData = new FormData();
      const res = await fetch(imageURL)
      const blob = await res.blob()
      const file = new File([blob], "image.png",{ type: "image/png" });
      formData.append("photo", file);
      const { data } = await post('https://hackathon-2uvycjffja-uc.a.run.app/imageProcess',
        formData , { "headers": { 
        "Authorization": `Bearer ${user.accessToken}` },
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'multipart/form-data'
      })
      if (data){
        setEmotion(data.success);
      }
    }
    getEmotion()
  },[location])

  return (
    <div className="photo-approval-container">
      <Helmet>
        <title>Photo-Approval - Hackathon</title>
        <meta property="og:title" content="Photo-Approval - Hackathon" />
      </Helmet>
      <PhotoHolder 
        rootClassName="photo-holder-root-class-name" 
        photoUrl={location.state.photoUrl}
      >
        <img className="photo-check" src={imageURL} />
      </PhotoHolder>
      <EmotionSelector 
        emotion={emotion}
        setEmotion={setEmotion}
      />
      <div className="photo-approval-container1">
        <Link to={"/daily-phrase"}
          state={{
            photoUrl: location.state.photoUrl,
            emotion,
            day: new Date().getDate(),
            month: new Date().getMonth()
          }} 
          className="nav-navlink" >
          <AcceptButton rootClassName="accept-button-root-class-name" />
        </Link>
        <Link to="/photo" className="nav-navlink" >
          <RetryButton rootClassName="retry-button-root-class-name" />
        </Link>
      </div>
    </div>
  )
}

export default PhotoApproval
